import { DoorEdge } from '../enums/door-edge';
import { DoorThickness } from '../enums/door-thickness';

export function thicknessEdges(edges: DoorEdge[], thickness: DoorThickness) {
  if (thickness === DoorThickness._138) {
    [...edges].filter(c => c !== DoorEdge.SQSQ).forEach(c => edges.remove(c));
  }
}
